import script from "./ViewSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSpace.vue?vue&type=script&setup=true&lang=js"

import "./ViewSpace.vue?vue&type=style&index=0&id=314d4c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314d4c0e"]])

export default __exports__